import React from "react";
import { TopPanel } from "./TopPanel";
import { banner_static } from "../../common/banner_static";
import { area_search } from "./area_search";
import { for_beginer } from "./for_beginer";
import { lineup } from "./lineup";
import { options } from "./options";
import { callcenter } from "./callcenter";
import { customer_voice } from "../../common/customer_voice";
import criteo from "../../lib/criteo";
// import { newslist } from "./newslist";
// import { TopBanner } from "../../common/TopBanner";

export class Top extends React.Component {
  componentDidMount() {
    document.title = `【業界物件数No.1】全国のトランクルームを探すなら『ハローストレージ』`;
  }
  render() {
    criteo.sendEvent({ event: "viewHome" })
    const { type, history } = this.props;
    return (
      <div className="container">
        <TopPanel {...{ type, history }}/>
        <div className="content">
          {banner_static(type)}
          {area_search(type, history)}
          {for_beginer(type)}
          {lineup(type)}
          {options(type)}
          {callcenter(type)}
          <div className="customer_voice_helper">{customer_voice(type)}</div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./pages/top/Top.jsx